var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "spinner spinner--double-bounce", style: _vm.styles },
    [
      _c("div", { staticClass: "double-bounce1", style: _vm.bounceStyle }),
      _vm._v(" "),
      _c("div", { staticClass: "double-bounce2", style: _vm.bounceStyle }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }